import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import {
  FormControl, InputGroup, Button, Modal,
} from 'react-bootstrap';
import { connect } from 'react-redux';
import { addSkill } from '../../redux/reduxActions/actions';
import 'react-toastify/dist/ReactToastify.css';
import { showToastError } from '../utils';

function AddNewSkill(props) {
  const [category_id, setCategory] = useState('');
  const [qualification_id, setQualification] = useState('');
  const [priority_id, setPriority] = useState('');
  const [min_rate, setMinPayment] = useState('');
  const [rate, setNormalPayment] = useState('');
  const [description, setAdditionalInfo] = useState('');
  const { qualifications, jobCategories, priorities } = props;
  const skillsSelection = Object.entries(qualifications)
    .map((level) => <option key={level[0]} value={level[0]}>{level[1]}</option>);
  const categoriesSelection = Object.entries(jobCategories)
    .map((category) => <option key={category[0]} value={category[0]}>{category[1]}</option>);
	  const prioritySelection = Object.entries(priorities)
    .map((priorityOption) => (
      <option key={priorityOption[0]} value={priorityOption[0]}>
        {priorityOption[1]}
      </option>
    ));
  // eslint-disable-next-line react/prop-types
  const handleShow = () => props.show();
  const createNewSkill = () => {
    if (!qualification_id
      || !priority_id
      || !category_id
      || !min_rate
      || !rate
    ) {
	    showToastError('Not all fields are filled');
      return;
    }
    const data = {
      qualification_id,
      category_id,
      priority_id,
      min_rate,
      rate,
      description,
    };
    props.addSkill(data);
    setCategory('');
    setQualification('');
    setPriority('');
    setMinPayment('');
    setNormalPayment('');
    setAdditionalInfo('');
    handleShow();
  };
  return (
    <div>
      {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
      <Modal show={props.isOpen} onHide={handleShow}>
        <Modal.Header closeButton>
          <Modal.Title>Add technology</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ display: 'flex' }}>
            <Form.Group style={{ width: '100%' }} controlId="formGridState">
              <Form.Label>Skill</Form.Label>
              <Form.Control as="select" onChange={(e) => setQualification(e.target.value)}>
                <option key="" value="">none</option>
                {skillsSelection}
              </Form.Control>
            </Form.Group>
            <Form.Group style={{ width: '100%' }} controlId="formGridState">
              <Form.Label>technology</Form.Label>
              <Form.Control as="select" onChange={(e) => setCategory(e.target.value)}>
                <option key="" value="">none</option>
                {categoriesSelection}
              </Form.Control>
            </Form.Group>
            <Form.Group style={{ width: '100%' }} controlId="formGridState">
              <Form.Label>priority</Form.Label>
              <Form.Control as="select" onChange={(e) => setPriority(e.target.value)}>
                <option key="" value="">none</option>
                {prioritySelection}
              </Form.Control>
            </Form.Group>
          </div>
          <div className="money-inputs">
            <InputGroup size="sm" className="mb-3">
              <InputGroup.Prepend>
                <InputGroup.Text id="inputGroup-sizing-sm">min payment $</InputGroup.Text>
              </InputGroup.Prepend>
              <FormControl
                aria-label="Small"
                type="number"
                aria-describedby="inputGroup-sizing-sm"
                onChange={({ target: { value } }) => setMinPayment(value)}
              />
            </InputGroup>
            <InputGroup size="sm" className="mb-3">
              <InputGroup.Prepend>
                <InputGroup.Text id="inputGroup-sizing-sm">normal payment $</InputGroup.Text>
              </InputGroup.Prepend>
              <FormControl
                aria-label="Small"
                type="number"
                aria-describedby="inputGroup-sizing-sm"
                onChange={({ target: { value } }) => setNormalPayment(value)}
              />
            </InputGroup>
          </div>
          <Form.Group controlId="exampleForm.ControlTextarea1">
            <Form.Label>Additional information</Form.Label>
            <Form.Control as="textarea" rows="3" onChange={(e) => setAdditionalInfo(e.target.value)} />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleShow}>
            Close
          </Button>
          <Button variant="primary" onClick={() => createNewSkill()} className="main-button-filled">
            Add
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
AddNewSkill.propTypes = {
  addSkill: PropTypes.func.isRequired,
};
export default connect((state) => ({
  priorities: state.skillsReducer.priorities,
  qualifications: state.skillsReducer.qualifications,
  jobCategories: state.skillsReducer.jobCategories,
}), { addSkill })(AddNewSkill);
